export var InsuranceTypes;
(function (InsuranceTypes) {
    InsuranceTypes["ONE"] = "1y";
    InsuranceTypes["TWO"] = "2y";
})(InsuranceTypes || (InsuranceTypes = {}));
//# sourceMappingURL=InsuranceTypes.js.map